import { PaletteMode } from "@mui/material";
import React from "react";

interface ColorContextSchema {
  selectedMode: PaletteMode;
  toggleColorMode: (mode: PaletteMode) => void;
}

export const ColorContext = React.createContext<ColorContextSchema>({} as ColorContextSchema);
